import { render, staticRenderFns } from "./veJkyFundClaimMy.vue?vue&type=template&id=1f685204&scoped=true"
import script from "./veJkyFundClaimMy.vue?vue&type=script&lang=js"
export * from "./veJkyFundClaimMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f685204",
  null
  
)

export default component.exports